<app-modal-actionable (openModalEvent)="initData()" [iconSrc]="icon" 
    [title]="this.titleModal ||'administration.sectionsManagement.' + section + '.' + type" color="purple" [data]="data"
    [dataIconSrc]="icon" [hideDialog]="hideDialog" class="modal-actionable">
    <img  *ngIf="!isField && !this.iconEditeSel" [src]="icon" alt="action icon" class="action-icon" id="action-icon">
    <img  *ngIf="!isField && this.iconEditeSel" [src]="this.iconEditeSel" alt="Edit select values" class="action-icon" id="action-icon">
    <span *ngIf="!isField && !hiddenTitle" title class="action-title" id="action-title">{{'administration.sectionsManagement.' + section + '.' + type | translate}}</span>
    <div *ngIf="isField" icon class="crud-icon fill-white" aria-label="type" [inlineSVG]="icon"></div>
    <div content *checkPermission="permissionCreate">
        <div ngbTooltip="{{('buttons.new' | translate) + ' ' + ('administration.sectionsManagement.modals.' + section + '.buttons.new.' + type | translate)}}"
            placement="left" container="body" tooltipClass="apc-tooltip-left" class="add-float-icon"  triggers="hover"
            (click)="addNewForm()">
            <div class="icon" aria-label="plus" [inlineSVG]="'assets/ico/plus-regular.svg'"></div>
        </div>
    </div>
    <div collapsable class="modal-footer p-0">
        <div class="container-fluid m-0 p-0">
            <div *ngIf="data" class="position-relative">
                <div id="modal-blanket" class="d-none"></div>
                <ng-template ngFor let-item [ngForOf]="forms.controls" let-i="index">
                    <app-collapsable-row [imgSrc]="icon" [title]="generateRowTitle(item, isField, type) || noValueTitle"
                        [isModal]="true" [isCollapsed]="getIsCollapsedValue(item)" [subsection]="subsection" [index]="i"
                        (collapseEvent)="toggleElement(item.value.identifier)" [isEdit]="getEditFormValue(item)" [blanketIsActive]="blanketIsActive"
                        [section]="this.section">
                        <apc-action-card [headerCursorPointer]="!getEditFormValue(item)">
                            <img icon [src]="icon" alt="user" />
                            <span title>{{ generateRowTitle(item, isField, type)}}</span>

                            <apc-admin-crud-action-buttons (editEvent)="editFormEvent(item, $event)" (readDisable)="changeReadDisable($event)"
                                [edit]="getEditFormValue(item)" (saveEvent)="saveForm(item)" (cancelEvent)="cancelForm(item)"
                                (preDeleteEvent)="hideDialog =  $event" (deleteEvent)="deleteItem(item)"
                                [section]="section" [subsection]="subsection" [context]="isField ? type : 'metadata'"
                                [pertinence]="pertinence" (downloadEvent)="download(item)" [form]="item" buttons>
                            </apc-admin-crud-action-buttons>
                            <div content class="fullwidth mb-3" [class.editForm]="!getEditFormValue(item)">
                                <form trapFocus [formGroup]="item">
                                    <div class="container-fluid">
                                        <apc-code-value-form *ngIf="showCodeValueForm"
                                            [showManager]="false"
                                            [managers]="managers" [form]="item" [section]="section"
                                            [subsection]="subsection" [type]="type">
                                        </apc-code-value-form>
                                        <apc-admin-profile-company-office-form *ngIf="showOfficeForm" [form]="item">
                                        </apc-admin-profile-company-office-form>
                                        <apc-admin-extras-form *ngIf="showExtraTypesForm" [readDisable]="readDisable" [form]="item" [type]="type">
                                        </apc-admin-extras-form>
                                        <!-- extra fields start -->
                                        <apc-extra-fields-note-form *ngIf="showExtraFieldNoteForm" [form]="item"
                                            [typesDropdown]="typesDropdown">
                                        </apc-extra-fields-note-form>

                                        <apc-extra-fields-file-form *ngIf="showExtraFieldFileForm" [form]="item"
                                            [typesDropdown]="typesDropdown" [fileFormData]="fileFormData"
                                            [fileRequired]="fileRequired">
                                        </apc-extra-fields-file-form>

                                        <apc-admin-certification-type *ngIf="showCertificationTypeForm" [form]="item"
                                            [fileFormData]="fileFormData" [fileRequired]="fileRequired">
                                        </apc-admin-certification-type>

                                        <apc-extra-fields-link-form *ngIf="showExtraFieldLinkForm" [form]="item"
                                            [typesDropdown]="typesDropdown">
                                        </apc-extra-fields-link-form>

                                        <apc-extra-fields-custom-field-form *ngIf="showExtraFieldCustomFieldForm"
                                            [form]="item" [typesDropdown]="typesDropdown">
                                        </apc-extra-fields-custom-field-form>

                                        <apc-admin-operations-solution *ngIf="showOperationsSolutionForm"
                                            [responsiblePersons]="managers" [form]="item">
                                        </apc-admin-operations-solution>

                                        <apc-admin-section-account-type *ngIf="showAccountTypeForm" [form]="item">
                                        </apc-admin-section-account-type>

                                        <apc-admin-section-identification-type *ngIf="showIdentificationTypeForm" [form]="item">
                                        </apc-admin-section-identification-type>
                                        <!-- equipment forms -->
                                        <apc-admin-equipment-companycar *ngIf="showEquipmentCompanycarForm" [form]="item">
                                        </apc-admin-equipment-companycar>

                                        <apc-admin-equipment-computer *ngIf="showEquipmentComputerForm" [form]="item">
                                        </apc-admin-equipment-computer>

                                        <apc-admin-equipment-fuelcard *ngIf="showEquipmentFuelcardForm" [form]="item">
                                        </apc-admin-equipment-fuelcard>

                                        <apc-admin-equipment-simcard *ngIf="showEquipmentSimcardForm" [form]="item">
                                        </apc-admin-equipment-simcard>

                                        <apc-admin-equipment-telepass *ngIf="showEquipmentTelepassForm" [form]="item">
                                        </apc-admin-equipment-telepass>
                                        <!-- equipment forms end -->


                                        <!-- extra fields end -->
                                    </div>
                                </form>
                            </div>
                        </apc-action-card>
                    </app-collapsable-row>
                </ng-template>
            </div>
        </div>
    </div>
</app-modal-actionable>